<template>
  <div>
    <v-card color="" elevation="0" class="">
      <v-divider></v-divider>
      <template>
        <v-tabs color="primary" v-model="tabs" class=" " height="80" background-color="#f4f4f4">
          <div class="d-flex align-center px-4  ">
            <v-icon color="primary" class="" size="">mdi-domain</v-icon>
            <h5 class="font-weight-bold headline ml-5">Gestão</h5>

          </div>
          <v-tab class="ml-4"> Usuários</v-tab>
          
          <v-tab class="ml-4">
            <span>Perfis associados</span>
          </v-tab>
          
          <v-tab class="ml-4" disabled>
            <span>Mídia kit</span>
            <v-chip 
              color="light-blue lighten-3" 
              text-color="white" 
              x-small 
              class="ml-2">
              Em breve
            </v-chip>
          </v-tab>
          
          <v-tab class="ml-4" disabled>
            <span>Políticas comerciais</span>
            <v-chip 
              color="light-blue lighten-3" 
              text-color="white" 
              x-small 
              class="ml-2">
              Em breve
            </v-chip>
          </v-tab>
          
          <v-tab class="ml-4" disabled>
            <span>Documentos</span>
            <v-chip 
              color="light-blue lighten-3" 
              text-color="white" 
              x-small 
              class="ml-2">
              Em breve
            </v-chip>
          </v-tab>
        </v-tabs>
      </template>
      <v-tabs-items v-model="tabs">
        <v-tab-item>
          <UsersList :type="'common-list'"></UsersList>
        </v-tab-item>
        
        <v-tab-item>
          <ProfilesList v-if="!isProfileDetails"></ProfilesList>
          <ProfileDetails v-else :profileId="profileId"></ProfileDetails>
        </v-tab-item>

      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import UsersList from '@/components/management/UsersList.vue';
import ProfilesList from '@/components/management/ProfilesList.vue';
import ProfileDetails from '@/components/management/ProfileDetails.vue';

export default {
  name: "ManagementTable",
  components: {
    UsersList,
    ProfilesList,
    ProfileDetails,
  },
  data() {
    return {
      tabs: 0,

    };
  },

  computed: {
    isProfileDetails() {
      return this.$route.path.includes('/profiles/') && this.$route.params.profileId;
    },
    profileId() {
      return this.$route.params.profileId;
    }
  },
  mounted() {
    this.loadTabs()
  },
  watch: {
    '$route.params.tab'() {
      this.loadTabs()
    },
    'tabs'(nV) {
      if (this.isProfileDetails) {
        return;
      }

      let query = []
      for (let key in this.$route.query) {
        if (nV != 0 && key == 'q') {
          query.push(`${key}=${this.$route.query[key]}`)
        }
      }
      const qstring = query.length ? `?${query.join('&')}` : ''

      if (nV == 0 && this.$route.fullPath != `/app/management/users${qstring}`) {
        this.$router.replace(`/app/management/users${qstring}`)
      } else if (nV == 1 && this.$route.fullPath != `/app/management/profiles${qstring}`) {
        this.$router.replace(`/app/management/profiles${qstring}`)
      }
    }
  },
  methods: {
    loadTabs() {
      if (this.$route.params.tab == 'users') {
        this.tabs = 0
      } else if (this.$route.params.tab == 'profiles' || this.isProfileDetails) {
        this.tabs = 1
      }
    }
  },
}
</script>

<style lang="scss" scoped>
* {
  font-family: 'Roboto', sans-serif !important;
}

.v-tab--disabled {
  opacity: 0.6 !important;
}
</style>